import { l as e } from "./lineHeights-72d3110c.mjs";
import { a as i } from "./themes-5f0b3c3d.mjs";
import { f as l } from "./fontWeights-a25f8f91.mjs";
const m = {
  headline: {
    xs: {
      fontSize: i.xsmall,
      fontWeight: l.headline,
      lineHeight: e.xsmall
    },
    s: {
      fontSize: i.small,
      fontWeight: l.headline,
      lineHeight: e.small
    },
    m: {
      fontSize: i.large,
      fontWeight: l.headline,
      lineHeight: e.medium
    },
    l: {
      fontSize: i.xxlarge,
      fontWeight: l.headline,
      lineHeight: e.large
    },
    xl: {
      fontSize: i.xxxxlarge,
      fontWeight: l.headline,
      lineHeight: e.xlarge
    },
    xxl: {
      fontSize: i.xxxxxlarge,
      fontWeight: l.headline,
      lineHeight: e.xxlarge
    }
  },
  eyebrow: {
    s: {
      fontSize: i.xxsmall,
      fontWeight: l.eyebrow,
      lineHeight: e.small
    },
    m: {
      fontSize: i.xsmall,
      fontWeight: l.eyebrow,
      lineHeight: e.medium
    },
    l: {
      fontSize: i.small,
      fontWeight: l.eyebrow,
      lineHeight: e.large
    }
  },
  body: {
    regular: {
      s: {
        fontSize: i.xsmall,
        fontWeight: l.body.regular,
        lineHeight: e.small
      },
      m: {
        fontSize: i.small,
        fontWeight: l.body.regular,
        lineHeight: e.medium
      },
      l: {
        fontSize: i.medium,
        fontWeight: l.body.regular,
        lineHeight: e.large
      }
    },
    medium: {
      s: {
        fontSize: i.xsmall,
        fontWeight: l.body.medium,
        lineHeight: e.small
      },
      m: {
        fontSize: i.small,
        fontWeight: l.body.medium,
        lineHeight: e.medium
      },
      l: {
        fontSize: i.medium,
        fontWeight: l.body.medium,
        lineHeight: e.large
      }
    },
    semibold: {
      s: {
        fontSize: i.xsmall,
        fontWeight: l.body.semibold,
        lineHeight: e.small
      },
      m: {
        fontSize: i.small,
        fontWeight: l.body.semibold,
        lineHeight: e.medium
      },
      l: {
        fontSize: i.medium,
        fontWeight: l.body.semibold,
        lineHeight: e.large
      }
    }
  }
};
export {
  m as t
};
